import api from '../index';

const campaignApprovalStepUpdaters = {
  add: async ({campaignId, step}: {campaignId: string; step: string}) => {
    return api.post(`campaigns/${campaignId}/approval_steps`, {step});
  },

  remove: async ({
    campaignId,
    campaignApprovalStepId,
  }: {
    campaignId: string;
    campaignApprovalStepId: string;
  }) => {
    return api.delete(
      `campaigns/${campaignId}/approval_steps/${campaignApprovalStepId}`
    );
  },
};

export default campaignApprovalStepUpdaters;
